import {
  ServiceItem,
  IndustryVertical,
  ProductTier,
  TechnicalDatasheet,
  Testimonial,
  FaqItem,
} from '../types';

export const COMPANY_INFO = {
  name: 'SIMATECH AUTOMATION',
  tagline: 'Industrial Process Automation Solution Provider & Siemens Channel Partner',
  isoCert: 'ISO 9001 : 2015 Certified Company',
  partnership: 'Official Siemens Channel Partner',
  establishedYear: '2006',
  experienceYears: '20+',
  globalDestinations: '14+',
  address: {
    street: 'No. 3, Saraswati Bldg., Tungareshwar Industrial Complex, Sativali',
    area: 'Vasai (East), Thane – 401 208',
    stateCountry: 'Maharashtra, India',
  },
  emails: [
    'sdd@simatechautomation.com',
    'info@simatechautomation.com',
    'sales@simatechautomation.com',
  ],
  phones: [
    '+91 9820234033',
    '+91 9920734033',
    '+91 8879663575',
  ],
  domains: ['simatechautomation.com', 'simatechautomation.in'],
  mission: 'To provide the most efficient, productive, and reliable automation solutions that directly maximize client productivity and plant safety.',
  vision: 'To deliver world-class automation technology with utmost customer satisfaction while upholding strict business ethics and technical standards.',
  qualityAssurance: 'Simatech maintains an in-house engineering and assembly unit dedicated to crafting precision control panels. Enclosures are manufactured to IP55 ratings, using high-grade components, LAPP internal wiring, and CE-compliant switchgear.',
  cableSpecialization: 'Simatech Automation has successfully executed extensive automation projects across Power Cables, Jelly Filled Telecommunication Cables (JFTC), and Fiber Optics manufacturing lines, establishing standardized project methodologies for tension control, capstan synchronization, and coiling automation.',
  methodologyPillars: [
    {
      title: 'Process Analysis',
      description: 'Every project begins with a systematic case study, P&ID review, and equipment specification.',
    },
    {
      title: 'User-Friendliness',
      description: 'Priority focus on intuitive operations, safe interface design, and ease of maintenance.',
    },
    {
      title: 'One-Stop Customized Solutions',
      description: 'Single-window support for electrical, hardware, software, and panel engineering.',
    },
  ],
  globalCountries: [
    'UAE', 'Saudi Arabia', 'Qatar', 'Nigeria', 'Kenya', 'South Africa',
    'Algeria', 'Syria', 'Argentina', 'Bangladesh', 'Sri Lanka', 'Philippines', 'Indonesia'
  ],
};

export const SERVICES_DATA: ServiceItem[] = [
  {
    id: 'consultancy',
    number: '01',
    category: 'Pre & Post Order',
    title: 'Consultancy',
    scope: 'Simatech professionals have the expertise needed to apply leading-edge technology to superior Automation solutions pre and post order.',
    keyFeatures: [
      'Understanding of the Clients requirement',
      'Suggesting the system suitable for the requirements',
      'Selection of the right control configuration',
      'Creation of the functional design specification',
      'Ensuring projects implementation',
    ],
    iconName: 'Compass',
  },
  {
    id: 'system-integration',
    number: '02',
    category: 'OEM Solutions',
    title: 'System Integration',
    scope: 'Discussion with Machine Manufacturers (OEM) to work out cost-effective standardized solutions encompassing all machine requirements.',
    keyFeatures: [
      'Discussion with the Machine Manufacturer (OEM)',
      'Selecting the right control configuration suitable for the machine',
      'Working out the cost effective standardize solution encompassing all the machine requirements',
      'Providing all the material and engineering support till the final implementation (at site)',
    ],
    iconName: 'Cpu',
  },
  {
    id: 'software-development',
    number: '03',
    category: 'PLC-HMI & SCADA',
    title: 'Software Development',
    scope: 'We have growing team of engineers working on PLC-HMI & SCADA software development from architecture to simulation.',
    keyFeatures: [
      'Project management',
      'Write the basic functional design specification',
      'Development of standard software block (library)',
      'Develop application software, simulation test',
      'Attending FAT, SAT & CAT',
    ],
    iconName: 'Code',
  },
  {
    id: 'amc',
    number: '04',
    category: 'Annual Maintenance Contract',
    title: 'Annual Maintenance Contract (AMC)',
    scope: 'Comprehensive preventive maintenance and breakdown coverage ensuring plant reliability and minimum downtime.',
    keyFeatures: [
      'Preventive maintenance',
      'Proper software backup',
      'Breakdown calls',
      'Documentation',
      'Spares management',
    ],
    iconName: 'ShieldCheck',
  },
  {
    id: 'retrofit-upgrades',
    number: '05',
    category: 'Technology Migration',
    title: 'Retrofit',
    scope: 'Changing obsolete, discontinued technology with latest automation platforms and Industry 4.0 standards.',
    keyFeatures: [
      'Changing the obsolete, discontinued technology by the latest technology',
      'Replacing OLD PLC-HMI model by latest PLC (S5 to S7 PLC)',
      'Replacing 6RA20, 6RA22, 6RA 24, 6RA70 to 6RA80',
      'Replacing master Drive by SINAMICS Drives',
      'Upgradation of the Control panel, Migration to industry 4.0',
    ],
    iconName: 'RefreshCw',
  },
  {
    id: 'commissioning',
    number: '06',
    category: 'Drive & PLC Panels',
    title: 'Commissioning of Drive, PLC panels',
    scope: 'We have very good pool of dedicated commissioning engineers executing projects across the length and breadth of India and 14+ countries.',
    keyFeatures: [
      'Dedicated pool of experienced commissioning engineers',
      'Commissioning across India and globally in UAE, Saudi Arabia, Qatar, Nigeria, Kenya, South Africa, Algeria, Syria, Argentina, Bangladesh, Sri Lanka, Philippines, Indonesia',
      'Drive loop tuning, calibration and complete Site Acceptance Testing (SAT)',
      'On-site operator and maintenance team technical training',
    ],
    iconName: 'Globe',
  },
  {
    id: 'breakdown-services',
    number: '07',
    category: 'Emergency Assistance',
    title: 'Breakdown Services',
    scope: 'Top priority breakdown resolution via remote AnyDesk/TeamViewer online support and rapid on-site engineer visits.',
    keyFeatures: [
      'We always give top most importance to the breakdown services',
      'We try to resolve the breakdown issues by means of phone calls, on line support by means of Any desk software, team viewer software, even in odd hours',
      'Our engineer visits the site for resolving the break down issues at a very short notice',
    ],
    iconName: 'Activity',
  },
  {
    id: 'plant-tech-conversion',
    number: '08',
    category: 'DC to AC Migration',
    title: 'Technology Conversion of plants',
    scope: 'Comprehensive plant DC to AC migration utilizing premium efficiency AC motors and properly engineered AC drives.',
    keyFeatures: [
      'DC motor to Premium efficiency AC Motor migration',
      'Right selection of the AC Drive as per the application',
      'Substantial reduction in factory power consumption',
      'Elimination of DC commutator & brush maintenance overhead',
    ],
    iconName: 'Zap',
  },
  {
    id: 'turnkey-automation',
    number: '09',
    category: 'Full EPC Lifecycle',
    title: 'Turnkey Automation Solution',
    scope: 'We provide turnkey solution for industrial process and factory automation right from design, manufacturing, engineering, testing, commissioning & customer training.',
    keyFeatures: [
      'Projects management',
      'Making of engineering drawing',
      'Procurements of drives and automation products including switchgears',
      'Panel manufacturing',
      'Supply of Field devices, cable trays, wires & cables',
      'Factory Acceptance Test (FAT)',
      'Installation at site',
      'Commissioning & SAT (Site Acceptance test)',
      'Client Training',
      'Documentation',
    ],
    iconName: 'Layers',
  },
  {
    id: 'panel-engineering',
    number: '10',
    category: 'Enclosure Fabrication',
    title: 'Panel Engineering',
    scope: 'Precision design and fabrication of IP55 control panels and desks conforming to international electrical safety norms.',
    keyFeatures: [
      'Development of Engineering drawing on EPLAN & Auto cad Software platform',
      'Installation and wiring of the panel as per the approved drawing from Client',
      'We use IP55 and upscale enclosures, control desk & junction box',
      'All the materials installed in the enclosure are CE certified including the Enclosure as well',
      'We use LAPP make wires for the panel wiring',
      'Panels are made in accordance with the electrical safety norms and guidelines followed across various countries',
    ],
    iconName: 'Settings',
  },
];

export const INDUSTRY_SECTORS: IndustryVertical[] = [
  {
    id: 'cable',
    sector: 'Cable & Telecommunications',
    title: 'Power, JFTC & Fiber Optics Cable Automation',
    tag: 'Specialized Discipline',
    scope: 'Power, JFTC & Fiber Optics lines, tension control loops, capstan synchronization, rewinding automation.',
    applications: [
      'Capstan speed & dancer tension synchronization',
      'High-speed rewinding & dual take-up control',
      'JFTC jelly filling & extrusion monitoring',
      'Fiber optic loose tube and buffering lines',
    ],
    image: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 'steel',
    sector: 'Iron & Steel Plants',
    title: 'Rolling Mill & Furnace Automation',
    tag: 'Heavy Industry',
    scope: 'Rolling mill drive synchronization, furnace charging & temperature control, API plant automation.',
    applications: [
      'Multi-stand rolling mill drive synchronization',
      'Automated furnace charging & push mechanism',
      'High-precision continuous casting control',
      'Heavy DC drive upgrades with SINAMICS 6RA80',
    ],
    image: '/images/about/control_panels_room.webp',
  },
  {
    id: 'pharma',
    sector: 'Pharmaceuticals',
    title: 'Cleanroom & API Plant Automation',
    tag: 'Regulated & Precision',
    scope: 'Batching systems, API plant automation, cleanroom HVAC control, fluid bed dryers, compression machinery.',
    applications: [
      'Recipe-driven automated batching systems',
      '21 CFR Part 11 compliant SCADA logging',
      'Fluid bed dryer & granulator automated loops',
      'Cleanroom differential pressure & HVAC control',
    ],
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 'chemical',
    sector: 'Chemical Processing',
    title: 'Reactor Control & Hazardous Area Automation',
    tag: 'Process Control',
    scope: 'Ultrasonic cleaning systems, reactor temperature/pressure loops, dosing lines, hazardous area control.',
    applications: [
      'Ex-proof and hazardous area IP55 control panels',
      'Precision chemical dosing & volumetric flow control',
      'Multi-stage exothermic reactor temperature control',
      'Ultrasonic cleaning tank cycle automation',
    ],
    image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 'rubber',
    sector: 'Rubber Processing',
    title: 'Mixer, Extruder & Vulcanization Controls',
    tag: 'Discrete & Batch',
    scope: 'Internal mixer control, extruder drive synchronization, vulcanization press control, calendar line automation.',
    applications: [
      'Internal mixer heavy torque & temperature profiling',
      'Multi-zone rubber extruder synchronization',
      'Hydraulic vulcanization press cycle sequencing',
      'Calendering line thickness & tension regulation',
    ],
    image: 'https://images.unsplash.com/photo-1581092335397-9583fe92d232?auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 'furnace',
    sector: 'Furnace Automation',
    title: 'Precision Temperature Profiling & Burner Controls',
    tag: 'Thermal Engineering',
    scope: 'Precision temperature profiling, burner management systems, heat treatment automated cycle control.',
    applications: [
      'Multi-zone PID precision temperature profiling',
      'NFPA compliant burner management systems (BMS)',
      'Automated heat treatment soaking & ramp cycles',
      'Oxygen trim and gas-air ratio optimization',
    ],
    image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 'water',
    sector: 'Water Treatment',
    title: 'Pumping Station & SCADA Monitoring',
    tag: 'Infrastructure',
    scope: 'Pumping station control, filtration backwash automation, chemical dosing, SCADA monitoring.',
    applications: [
      'Multi-pump cascade & pressure management',
      'Automated sand/carbon filter backwash sequences',
      'Remote telemetry & municipal SCADA integration',
      'Chlorination & pH chemical dosing regulation',
    ],
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 'oil-gas',
    sector: 'Oil & Gas',
    title: 'Upstream, Midstream & Pipeline Automation',
    tag: 'Energy & Petrochemicals',
    scope: 'Offshore rig telemetry, pipeline pump station automation, custody transfer metering, SIL-3 ESD safety systems.',
    applications: [
      'SIL-3 Emergency Shutdown (ESD) & Fire & Gas (F&G) systems',
      'High-pressure gas compressor & booster pump station control',
      'SCADA telemetry for long-distance oil & gas pipeline corridors',
      'Custody transfer flow metering & automated valve manifolds',
    ],
    image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 'material-handling',
    sector: 'Material Handling & Logistics',
    title: 'ASRS, Cranes & Conveyor Synchronization',
    tag: 'Factory Logistics',
    scope: 'Automated storage & retrieval (ASRS), conveyor sync, cranes, stacker control, sorting lines.',
    applications: [
      'Automated Storage and Retrieval Systems (ASRS)',
      'High-speed sorting & diverter conveyor lines',
      'Overhead crane multi-axis position & anti-sway sync',
      'Palletizer & stacker robotic cell integration',
    ],
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=800&q=80',
  },
];

export const PRODUCT_TIERS: ProductTier[] = [
  {
    id: 'drives',
    title: 'Electrical Drives (VFD & Servo)',
    subtitle: 'Low Voltage AC & DC Drive Systems',
    category: 'Siemens SINAMICS Series',
    badge: 'Core Offering',
    icon: 'Zap',
    models: [
      'SINAMICS G120C & G120P Series',
      'SINAMICS G120, V20 & S120 Modules',
      'SINAMICS G120X & G130 High Power',
      'SINAMICS G110M/D, G150, G180, S150',
      'SINAMICS V90 & S210 Servo Drives',
      'SINAMICS DC MASTER 6RA80 Series',
    ],
    highlights: [
      'Comprehensive power range from fractional kW to MW ratings',
      'Native PROFINET, PROFIBUS & Modbus fieldbus support',
      'Integrated Safe Torque Off (STO) & motion safety',
      'Direct retrofit replacement for legacy DC drives',
    ],
  },
  {
    id: 'plcs',
    title: 'SIMATIC PLCs & Distributed I/O',
    subtitle: 'Controllers for Basic to Advanced Automation',
    category: 'Siemens SIMATIC Platform',
    badge: 'Industry Standard',
    icon: 'Cpu',
    models: [
      'SIMATIC S7-200 SMART Micro PLCs',
      'SIMATIC S7-1200 Compact Controllers',
      'SIMATIC S7-1500 Advanced Automation',
      'SIMATIC S7-300 & S7-400 Legacy Line',
      'Distributed I/O: ET-200S & ET-200M',
      'SIMATIC ET-200SP High Density Stations',
    ],
    highlights: [
      'High processing speed for deterministic cycle execution',
      'Modular rack expansion with fail-safe safety I/O modules',
      'Seamless engineering in Siemens TIA Portal',
      'Direct web server diagnostics & OPC-UA communication',
    ],
  },
  {
    id: 'hmi-scada',
    title: 'HMI, SCADA & Industrial PCs',
    subtitle: 'Visualization, Analytics & Servomotors',
    category: 'Siemens Plant Telemetry',
    badge: 'Turnkey Control',
    icon: 'Monitor',
    models: [
      'SIMATIC KTP Series Basic Panels',
      'SIMATIC Comfort Panels & Mobile Panels',
      'SIMATIC WinCC Professional SCADA',
      'SIMATIC WinCC V7.x Enterprise SCADA',
      'SIMATIC Industrial PCs (Rack & Box IPC)',
      'Motors: 1PH8, V90 1FL6, S210, 1FK7/1FT7',
    ],
    highlights: [
      'High-resolution touchscreen displays with IP65 front',
      'Real-time recipe management, alarms & historical trends',
      'Rugged industrial PC hardware for harsh plant environments',
      'High-dynamic synchronous & asynchronous servomotors',
    ],
  },
];

export const TECHNICAL_DATASHEETS: TechnicalDatasheet[] = [
  {
    id: 'sinamics-g120',
    title: 'Siemens SINAMICS G120 / G120C VFD Selection Guide',
    category: 'VFD Drives Catalog',
    filename: 'Siemens_SINAMICS_G120_G120C_Selection_Guide.pdf',
    fileSize: '4.8 MB',
    description: 'Full technical specification catalog for Siemens low voltage AC drives, power ratings, frame sizes, and terminal drawings.',
    availableContent: [
      'Power ratings (0.55 kW to 132 kW) & frame sizes FSA - FSF',
      'Control Units (CU240E-2, CU250S-2) & I/O terminal diagrams',
      'Integrated braking modules & reactor sizing parameters',
      'PROFINET, PROFIBUS, Modbus RTU & CANopen communication protocols',
      'Dimensional line drawings & installation clearance guidelines',
    ],
    accessUrl: '/product',
  },
  {
    id: 'simatic-s7',
    title: 'Siemens SIMATIC S7-1200 / S7-1500 Controller Manual',
    category: 'PLC Hardware Manual',
    filename: 'Siemens_SIMATIC_S7-1200_S7-1500_Manual.pdf',
    fileSize: '6.2 MB',
    description: 'Hardware execution performance manual for SIMATIC controllers detailing CPU limits, execution speed, and motion safety.',
    availableContent: [
      'CPU memory limits, work memory & bit execution speed (<10 ns)',
      'Motion control capabilities: PTO, PWM & PROFINET IRT axis sync',
      'Safety I/O modules & SIL 3 / PL e integration guidelines',
      'Expansion rack limits, signal boards & communication processors',
      'TIA Portal v18/v19 setup & diagnostic buffer interpretation',
    ],
    accessUrl: '/product',
  },
  {
    id: 'dc-master-6ra80',
    title: 'SINAMICS DC MASTER 6RA80 Retrofit & Application Guide',
    category: 'Retrofit Engineering Guide',
    filename: 'SINAMICS_6RA80_Retrofit_Application_Guide.pdf',
    fileSize: '3.9 MB',
    description: 'Engineering guide for upgrading legacy DC drives (6RA24/6RA70) with migration charts, field ratings, and retrofit schematics.',
    availableContent: [
      'Armature and field current ratings from 15 A up to 3000 A',
      'Step-by-step parameter translation from 6RA24/6RA70 to 6RA80',
      'Encoder feedback wiring, tachometer & resolver compatibility',
      'Retrofit schematic diagrams & mechanical adapter bracket drawings',
      'Field weakening, torque control & rolling mill application notes',
    ],
    accessUrl: '/product',
  },
  {
    id: 'corporate-brochure',
    title: 'Simatech Automation Corporate Capabilities & Services Brochure',
    category: 'Corporate Overview',
    filename: 'Simatech_Automation_Corporate_Brochure.pdf',
    fileSize: '5.1 MB',
    description: 'Official brochure detailing panel fabrication capabilities, ISO standards, and global project references.',
    availableContent: [
      'IP55 enclosure fabrication standards & CNC sheet metal specifications',
      'LAPP internal wiring, ferrule identification & CE switchgear compliance',
      'FAT (Factory Acceptance) & SAT (Site Acceptance) testing protocols',
      'Client case studies: Bhushan Steel, Universal Cables, Nexans Qatar',
      'Global commissioning procedures across 14+ international territories',
    ],
    accessUrl: '/services',
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    "id": "1790343530262",
    "clientName": "S.C. Vaidya",
    "role": "Chief Technical Officer",
    "company": "Universal Cable Limited",
    "location": "Satna",
    "projectType": "Chief Technical Officer - Universal Cable Limited",
    "quote": "We appreciate technical know -how and extensive support of SIMATECH AUTOMATION and their high quality in manufacturing and support, sincerity in supply, installation and commissioning of Electrical upgradation of our PLCV LINE, with HIGH END technology.",
    "avatar": "https://ui-avatars.com/api/?name=S.C.%20Vaidya&background=1b7481&color=fff&size=128"
  },
  {
    "id": "1790343614238",
    "clientName": "Jitendra Sonar",
    "role": "General Manager - Projects",
    "company": "KEC Asian Cables Ltd.",
    "location": "Vadodara",
    "projectType": "General Manager - Projects - KEC Asian Cables Ltd.",
    "quote": "We are delighted to express our complete satisfaction with the successful completion and commissioning of the 61 Bobbin RST machine supplied by Hi-Fei Smarter and expertly handled by Simatech Automation. The Simatech Automation team showcased exceptional professionalism, technical expertise, and dedication throughout the entire project lifecycle.",
    "avatar": "https://ui-avatars.com/api/?name=Jitendra%20Sonar&background=1b7481&color=fff&size=128"
  },
  {
    "id": "1790343681470",
    "clientName": "Ravishankar Prajapati ",
    "role": "DGM - Maintenance",
    "company": "KEC Asian Cables Ltd.",
    "location": "Vadodara",
    "projectType": "DGM - Maintenance - KEC Asian Cables Ltd.",
    "quote": "We, KEC Asian Cables Ltd., would like to express our sincere appreciation to Simatech Automation for their exceptional efforts in upgrading the Extruder Drive from the old Sinamics G120 drive version to the new version, integrated with the SIMATIC S7-300 Safety PLC over the PROFINET network.",
    "avatar": "https://ui-avatars.com/api/?name=Ravishankar%20Prajapati%20&background=1b7481&color=fff&size=128"
  }
];

export const FAQS_DATA: FaqItem[] = [
  {
    id: 'faq-1',
    category: 'Quality & Manufacturing',
    question: 'What quality standards and warranties do you provide for control panels?',
    answer: 'All Simatech Automation control panels are manufactured in our in-house facility adhering to ISO 9001:2015 quality systems. Panels feature IP55 environmental protection ratings, CE-compliant switchgear, structured LAPP internal wiring with clear ferrule numbering, and undergo 100% rigorous Factory Acceptance Testing (FAT) with digital simulation before dispatch.',
  },
  {
    id: 'faq-2',
    category: 'Project Timeline',
    question: 'How long does it take to design, manufacture, and commission a turnkey project?',
    answer: 'Typical turnaround varies with system complexity: standard control panels and retrofits take 2 to 4 weeks, while comprehensive multi-drive turnkey automation projects (including P&ID analysis, EPLAN electrical schematics, PLC/SCADA programming, panel fabrication, FAT, and on-site commissioning) span 6 to 10 weeks.',
  },
  {
    id: 'faq-3',
    category: 'Project Initiation',
    question: 'What information do you need to start our automation project?',
    answer: 'To formulate an initial Functional Design Specification (FDS) and proposal, we require: (1) Process description or P&ID diagram, (2) Motor and drive power ratings / voltage levels, (3) Expected I/O channel count and communication preferences (PROFINET / PROFIBUS), and (4) Any target cycle time or specific OEM mechanical constraints.',
  },
  {
    id: 'faq-4',
    category: 'Retrofit & Modernization',
    question: 'Can Simatech handle legacy retrofit for obsolete Siemens systems (e.g. S5 to S7, 6RA24/70 to 6RA80)?',
    answer: 'Yes. Retrofit is one of our flagship specializations. We convert legacy Siemens SIMATIC S5 PLCs to modern S7-1500/S7-1200 controllers and migrate older 6RA24 / 6RA70 DC drives to the latest SINAMICS 6RA80 DC MASTER series with minimal plant downtime and parameter mapping.',
  },
  {
    id: 'faq-5',
    category: 'Support & Global Scope',
    question: 'How do your breakdown assistance and international commissioning services operate?',
    answer: 'We provide immediate 24/7 remote diagnostics via AnyDesk and TeamViewer for rapid software/fault resolution. For on-site commissioning and physical breakdown attendance, our certified field engineers travel across India and have successfully commissioned plants in over 14 countries worldwide.',
  },
  {
    id: 'faq-6',
    category: 'Quality Assurance & Testing',
    question: 'How do you ensure equipment quality and compliance before dispatch?',
    answer: 'Every control panel undergoes 100% Factory Acceptance Testing (FAT) with point-to-point wiring continuity verification, high-voltage insulation checks, digital I/O loop simulation in Siemens TIA Portal, and thermal profiling before site delivery.',
  },
];
